import React from "react";
import {
    View,
    Text,
    StyleSheet,
    Svg,
    Path,
    G,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    icon: {
        marginRight: "3px",
    },
    text: {
        fontSize: "8px",
        color: "#adb7c0",
        fontWeight: "bold",
    }
});

const Icon = () => (
    <Svg id="Upcoming_Icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 39.745 39.745">
        <Path id="Ellipse_717-7" data-name="Ellipse 717-7" d="M19.872,0A19.872,19.872,0,1,1,0,19.872,19.872,19.872,0,0,1,19.872,0Z" transform="translate(0 0)" fill="#adb7c0" />
        <G id="Group_11470" data-name="Group 11470" transform="translate(9.131 11.918)">
            <G id="np_like_888708_000000" transform="translate(0 0)">
                <Path id="Path_36421" data-name="Path 36421" d="M45.238,21.417a.871.871,0,0,0-.879-.879H41.721c-.14,0-.633-.211-.246-.809a8.124,8.124,0,0,0,.246-2.181.879.879,0,0,0-1.759,0A3.615,3.615,0,0,1,37.5,20.889v4.573c1.126.387,1.407,1.055,2.814,1.055h2.638a.879.879,0,0,0,.7-1.407.871.871,0,0,0,.879-.879.958.958,0,0,0-.211-.6.867.867,0,0,0,.563-.809.958.958,0,0,0-.211-.6.847.847,0,0,0,.563-.809Z" transform="translate(-33.983 -16.668)" fill="#fff" />
                <Path id="Path_36422" data-name="Path 36422" d="M18.426,37.5H16.668v5.98h1.759a1.058,1.058,0,0,0,1.055-1.055v-3.87A1.036,1.036,0,0,0,18.426,37.5Z" transform="translate(-16.668 -33.983)" fill="#fff" />
            </G>
            <G id="np_like_888708_000000-2" data-name="np_like_888708_000000" transform="translate(10.227 6.061)">
                <Path id="Path_36423" data-name="Path 36423" d="M37.5,21.768a.871.871,0,0,0,.879.879h2.638c.14,0,.633.211.246.809a8.124,8.124,0,0,0-.246,2.181.879.879,0,0,0,1.759,0A3.615,3.615,0,0,1,45.238,22.3V17.723c-1.126-.387-1.407-1.055-2.814-1.055H39.786a.879.879,0,0,0-.7,1.407.871.871,0,0,0-.879.879.958.958,0,0,0,.211.6.867.867,0,0,0-.563.809.958.958,0,0,0,.211.6.847.847,0,0,0-.563.809Z" transform="translate(-37.5 -16.668)" fill="#fff" />
                <Path id="Path_36424" data-name="Path 36424" d="M17.724,43.48h1.758V37.5H17.723a1.058,1.058,0,0,0-1.055,1.055v3.87a1.036,1.036,0,0,0,1.055,1.055Z" transform="translate(-8.227 -37.148)" fill="#fff" />
            </G>
        </G>
    </Svg>
)

const UpcomingIcon = () => (
    <View style={styles.container}>
        <View style={styles.icon}>
            <Icon />
        </View>
        <Text style={styles.text}>Upcoming</Text>
    </View>
);

export default UpcomingIcon;
